import { useSyncedRef } from "@react-hookz/web";
import type { OptionsObject } from "notistack";
import { useSnackbar } from "notistack";
import type { ReactNode } from "react";
import { useCallback } from "react";

import { useSimpleSnackbarContext } from "./contexts";

export type Props = {
  duration?: number;
  leftElement: ReactNode;
  rightElement: ReactNode;
};

export const useSnackbarSimple = (config?: OptionsObject) => {
  const { enqueueSnackbar } = useSnackbar();
  const { enabled = true } = useSimpleSnackbarContext();

  const configReference = useSyncedRef(config);
  const handleOpenSnackbar = useCallback(
    ({ duration, leftElement, rightElement }: Props) => {
      if (!enabled) return;
      enqueueSnackbar({
        ...configReference.current,
        autoHideDuration: duration,
        leftElement,
        rightElement,
        style: {
          ...configReference.current?.style,
        },
        variant: "simple",
      });
    },
    [enabled, enqueueSnackbar, configReference],
  );

  return {
    handleOpenSnackbar,
  };
};
